// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordChanged_wrapper__qzZ9u","infoContainer":"PasswordChanged_infoContainer__3wzFw","img":"PasswordChanged_img__07AWc"};